import { useAdOverlayMatches } from '@app/modules/audit/hooks/useAdOverlayMatchs';
import { parseRangeFromTs } from '@mi-front/core';
import { useContext } from 'react';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { useAuditLiveMentionsMatches } from '../../../../../audit/hooks/useAuditLiveMentionsMatches';
import { useAuditSpotMatches } from '../../../../../audit/hooks/useAuditSpotMatches';
import { DiarizationContext } from '../../diarization/DiarizationContext';
import { useStreamSegmentsRange } from '../../hooks/segments/useStreamSegmentsQuery';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';

export function useRangeAuditResults() {
  const station = useActiveStation();
  const range = useStreamSegmentsRange();

  const matchesQuery = useAuditSpotMatches(station, parseRangeFromTs(range));
  const { diarization, diarizationRefetch } = useContext(DiarizationContext);
  const liveMentionsQuery = useAuditLiveMentionsMatches(station, parseRangeFromTs(range));
  const adoverlayQuery = useAdOverlayMatches(station, parseRangeFromTs(range));
  const settingsAudit = useStreamSettingsStore((state) => state.audit);

  return {
    data: {
      matches: (settingsAudit.matches && matchesQuery.data) || [],
      liveMentions: (settingsAudit.liveMentions && liveMentionsQuery.data) || [],
      diarizations: (settingsAudit.diarization && diarization) || [],
      adoverlays: (settingsAudit.adoverlay && adoverlayQuery.data) || [],
    },
    reload: () => {
      matchesQuery.refetch();
      liveMentionsQuery.refetch();
      diarizationRefetch();
      adoverlayQuery.refetch();
    },
  };
}
